import { Table } from "antd";
import React from "react";
import { useCollection } from "../../../hooks/useCollection";
import { ColorPricesPopup } from "./ColorPricesPopup";

export default function ColorPrices() {
   const { loading, data } = useCollection("colorPrices");
   const columns = [
      {
         title: "Type",
         dataIndex: "type",
      },
      {
         title: "Price",
         dataIndex: "price",
         align: "center",
         sorter: {
            compare: (a, b) => a.price - b.price,
         },
      },
      {
         render: (value) => <ColorPricesPopup title={value.type} price={value.price} id={value.id} />,
      },
   ];

   const onChange = (pagination, filters, sorter, extra) => {
      console.log("params", pagination, filters, sorter, extra);
   };

   return (
      <div>
         <Table columns={columns} size="small" loading={loading} dataSource={data} onChange={onChange} pagination={false} />
      </div>
   );
}
